import { Component } from '@angular/core'

@Component({
  templateUrl: './student-manual-ru.component.html',
  styleUrls: ['../student-manual.component.less'],
  selector: 'app-student-manual-ru',
})
export class StudentManualComponentRu {}
